<template>
 <div>
   <Autocomplete v-model="ChiaveUtente"
                 :placeholder="this.GetTraduzioneLabel('VUEInputUtenti','TKN_UTENTE_INS_PLACEHOLDER',this.LinguaUtente)"
                 FieldChiave = "CHIAVE"
                 FieldDescrizione = "RAGIONE_SOCIALE"
                 InvalidValue = "-1"
                 InputClasses="form-control"
                 :items="ListaUtentiModificata"
                 :disabled="disabled"
                 :minInputLength="1" />
 </div>
</template>

<script>
import { SystemInformation, RUOLI } from '@/SystemInformation';
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';
import Autocomplete from '@/utils/ZAutocomplete.vue'

 export default 
 {
    mixins: [ MixInsGestioneTraduzioni ],
    data()
    {
       return {
                ChiaveUtente : -1,
                LinguaUtente : SystemInformation.UserInformation.Lingua,
                Utenti       : []
              }
    },
    props : [ 'modelValue' ,'disabled', 'UtentiDaEscludere'],
    components: 
    {
     Autocomplete
    },
    mounted()
    {
      this.ChiaveUtente = this.modelValue;
    },
    computed : 
    {
      ListaUtentiModificata:
      {
        get()
        { 
          let UtentiTot = this.Utenti       
          let UtentiDaEscludere = this.UtentiDaEscludere
          let UtentiFiltrati = []
          if (UtentiDaEscludere != undefined)
            UtentiFiltrati = UtentiTot.filter(function(Utente){
                                                                for(let i = 0; i < UtentiDaEscludere.length; i++)
                                                                {
                                                                  if (UtentiDaEscludere[i].CHIAVE == Utente.CHIAVE)
                                                                  {
                                                                    return false
                                                                  }
                                                                }
                                                                return true
                                                              })
          else
            for (let i = 0; i < UtentiTot.length; i++)
            {
              let Utente = UtentiTot[i]
              UtentiFiltrati.push(Utente)
            }
          return UtentiFiltrati        
        }
      }
    },
    methods :
    {

    },
    watch :
    {
      ChiaveUtente :
      {
        handler(NewValue)
        {
           if(NewValue != undefined)
              this.$emit('update:modelValue',NewValue)
        }
      },
      modelValue :
      {
           handler(NewValue)
           {
             this.ChiaveUtente = NewValue;
           }
      },
    },
    beforeMount()
    {
      let Self = this
      let Modello = 'SuperUtente_GestioneUtenti'
      if (SystemInformation.UserInformation.Ruolo == RUOLI.Amministratore)
        Modello = 'Admin_GestioneUtenti'
      SystemInformation.AdvQuery.GetSQL(Modello,{},
                                            function(Results)
                                            {
                                              Self.Utenti = SystemInformation.AdvQuery.FindResults(Results, 'Lista')
                                            },
                                            SystemInformation.HandleError, 'SelectUtentiPerInput');   
    }
 }
</script>

<style lang="scss" scoped>

</style>